import React from 'react';
import s from './StatPrototype.module.css';

// ── Sample data (mirrors real seed values) ──────────────────────────────────
const DATA = {
  evaluaciones: {
    total: 20,
    items: [
      { label: 'Completadas', value: 10 },
      { label: 'En curso', value: 7 },
      { label: 'Con conflicto de interés', value: 2, danger: true },
      { label: 'Rechazadas', value: 1, danger: true },
    ],
  },
  evaluadores: {
    total: 8,
    items: [
      { label: 'Internos UC', value: 5 },
      { label: 'Externos', value: 3 },
      { label: 'Sin confirmar', value: 1, danger: true },
    ],
  },
  coi: {
    total: 20,
    items: [
      { label: 'Sin declarar', value: 7, danger: true },
      { label: 'Sin conflicto', value: 11 },
      { label: 'Con conflicto', value: 2, danger: true },
    ],
  },
  instituciones: {
    total: 10,
    items: [
      { label: 'Chilenas', value: 3 },
      { label: 'Internacionales', value: 7 },
    ],
  },
  pool: {
    total: 36,
    items: [
      { label: 'Con evaluador', value: 8 },
      { label: 'Sin evaluador', value: 28, danger: true },
    ],
  },
};

// ── Alternativa A — Chip total ───────────────────────────────────────────────
const ChipStat: React.FC<{
  label: string;
  total: number;
  items: { label: string; value: number; danger?: boolean }[];
}> = ({ label, total, items }) => (
  <div className={`${s.card} ${s.variantA}`}>
    <span className={s.cardLabel}>{label}</span>
    <div className={s.variantARow}>
      <div className={s.chipTotal}>
        <span className={s.chipTotalNumber}>{total}</span>
        <span className={s.chipTotalLabel}>Total</span>
      </div>
      <div className={s.chipDivider} />
      <div className={s.chipItems}>
        {items.map((item) => (
          <div key={item.label} className={s.chipItem}>
            <span className={`${s.chipItemNumber}${item.danger ? ` ${s.danger}` : ''}`}>
              {item.value}
            </span>
            <span className={s.chipItemLabel}>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

// ── Alternativa B — Size hierarchy ───────────────────────────────────────────
const SizeStat: React.FC<{
  label: string;
  total: number;
  items: { label: string; value: number; danger?: boolean }[];
}> = ({ label, total, items }) => (
  <div className={`${s.card} ${s.variantB}`}>
    <span className={s.cardLabel}>{label}</span>
    <div className={s.variantBRow}>
      <div className={s.sizeTotal}>
        <span className={s.sizeTotalNumber}>{total}</span>
        <span className={s.sizeTotalLabel}>Total</span>
      </div>
      <span className={s.sizeSep}>|</span>
      <div className={s.sizeItems}>
        {items.map((item) => (
          <div key={item.label} className={s.sizeItem}>
            <span className={`${s.sizeItemNumber}${item.danger ? ` ${s.danger}` : ''}`}>
              {item.value}
            </span>
            <span className={s.sizeItemLabel}>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

// ── Page ─────────────────────────────────────────────────────────────────────
const StatPrototype: React.FC = () => (
  <div className={s.page}>
    <p className={s.pageTitle}>Prototipo de componente StatSummary</p>
    <p className={s.pageNote}>Página temporal · borrar después de decidir variante</p>

    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'start' }}>

      {/* Alternativa A */}
      <div className={s.section}>
        <p className={s.sectionTitle}>Alternativa A — Chip de color</p>
        <p style={{ fontSize: '0.8125rem', color: 'var(--color-gray-500)', marginBottom: '1rem' }}>
          Total en chip azul sólido. Jerarquía por color + forma. Fácil de ubicar de un vistazo.
        </p>
        <div className={s.stack}>
          <ChipStat label="Evaluaciones" {...DATA.evaluaciones} />
          <ChipStat label="Evaluadores" {...DATA.evaluadores} />
          <ChipStat label="Declaración Conflicto de Interés" {...DATA.coi} />
          <ChipStat label="Instituciones participantes" {...DATA.instituciones} />
          <ChipStat label="Asignaciones · Pool" {...DATA.pool} />
        </div>
      </div>

      {/* Alternativa B */}
      <div className={s.section}>
        <p className={s.sectionTitle}>Alternativa B — Jerarquía por tamaño</p>
        <p style={{ fontSize: '0.8125rem', color: 'var(--color-gray-500)', marginBottom: '1rem' }}>
          Total más grande, sin caja. Jerarquía solo por peso tipográfico. Más silencioso, menos color.
        </p>
        <div className={s.stack}>
          <SizeStat label="Evaluaciones" {...DATA.evaluaciones} />
          <SizeStat label="Evaluadores" {...DATA.evaluadores} />
          <SizeStat label="Declaración Conflicto de Interés" {...DATA.coi} />
          <SizeStat label="Instituciones participantes" {...DATA.instituciones} />
          <SizeStat label="Asignaciones · Pool" {...DATA.pool} />
        </div>
      </div>

    </div>
  </div>
);

export default StatPrototype;
